import React, { useEffect } from "react"
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom"
import { Stepper, StepperContent, StepperIndicator, StepperItem,
  StepperNav, StepperPanel, StepperSeparator, StepperTrigger } from "components/ui/stepper"
import { Button } from "components/ui/button"
import { CLIENT_ADD_STEPS } from "@/types/StepForm"
import { ChevronLeft } from "lucide-react"
import CustomStepper from "components/common/stepper/CustomStepper"

export type AddClientStepFormPropsType = {

}

function AddClientStepper(props : AddClientStepFormPropsType) {
    const navigate = useNavigate();
    const location = useLocation();

    // Déterminer l'étape actuelle basée sur l'URL
    const currentStep = CLIENT_ADD_STEPS.find(step =>
      location.pathname.includes(step.pathName)
    );
    const currentStepIndex = currentStep?.id || 1;

    // Rediriger vers la première étape si on est sur la route de base
    useEffect(() => {
      if (location.pathname.endsWith('/ajout-client') || location.pathname.endsWith('/ajout-client/')) {
        navigate(CLIENT_ADD_STEPS[0].pathName, { replace: true });
      }
    }, [location.pathname, navigate]);

    // const handleStepChange = (step: number) => {
    //   const selectedStep = CLIENT_ADD_STEPS.find(s => s.id === step);
    //   if (selectedStep) {
    //     navigate(selectedStep.pathName);
    //   }
    // };
    //
    // const handleNext = () => {
    //   if (currentStepIndex < CLIENT_ADD_STEPS.length) {
    //     const nextStep = CLIENT_ADD_STEPS.find(s => s.id === currentStepIndex + 1);
    //     if (nextStep) navigate(nextStep.pathName);
    //   }
    // };
    //
    // const handlePrevious = () => {
    //   if (currentStepIndex > 1) {
    //     const prevStep = CLIENT_ADD_STEPS.find(s => s.id === currentStepIndex - 1);
    //     if (prevStep) navigate(prevStep.pathName);
    //   }
    // };

    return (
      <>
        <div>
            <Link to="/" className="inline-flex gap-x-2 text-blue-600">
              <ChevronLeft size="20" /> Retour à l' accueil
            </Link>
        </div>
        <div className="flex flex-col gap-5 p-10 w-full mx-auto justify-center items-center">
          <CustomStepper steps={CLIENT_ADD_STEPS} className="" showDefaultButtons={false} />
          {/*<Stepper value={currentStepIndex} onValueChange={handleStepChange} className="space-y-8">*/}
          {/*  <StepperNav>*/}
          {/*    {CLIENT_ADD_STEPS.map((step) => (*/}
          {/*      <StepperItem key={step.id} step={step.id}>*/}
          {/*        <StepperTrigger asChild>*/}
          {/*          <StepperIndicator className="data-[state=completed]:bg-green-500 data-[state=completed]:text-white data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=inactive]:text-gray-500">*/}
          {/*            {step.id}*/}
          {/*          </StepperIndicator>*/}
          {/*        </StepperTrigger>*/}
          {/*        {CLIENT_ADD_STEPS.length > step.id && <StepperSeparator className="group-data-[state=completed]/step:bg-green-500" />}*/}
          {/*      </StepperItem>*/}
          {/*    ))}*/}
          {/*  </StepperNav>*/}

          {/*  <StepperPanel className="text-sm">*/}
          {/*    {CLIENT_ADD_STEPS.map((step) => (*/}
          {/*      <StepperContent className="w-full flex items-center justify-center" key={step.id} value={step.id}>*/}
          {/*        <div className="bg-white px-7 py-6 rounded-xl max-w-[600px]">*/}
          {/*          /!* Utilisez Outlet au lieu de Routes imbriquées *!/*/}
          {/*          <Outlet />*/}
          {/*        </div>*/}
          {/*      </StepperContent>*/}
          {/*    ))}*/}
          {/*  </StepperPanel>*/}

          {/*  <div className="flex items-center justify-between gap-2.5">*/}
          {/*    <Button variant="outline" onClick={handlePrevious} disabled={currentStepIndex === 1}>*/}
          {/*      Retour*/}
          {/*    </Button>*/}
          {/*    <Button onClick={handleNext} disabled={currentStepIndex === CLIENT_ADD_STEPS.length}>*/}
          {/*      Suivant*/}
          {/*    </Button>*/}
          {/*  </div>*/}
          {/*</Stepper>*/}
        </div>
      </>
    );

}
//   const [currentStepIndex, setCurrentStepIndex] = useState(1);
//
//   const navigate = useNavigate();
//
//   const handleStepChange = (step : number) => {
//     setCurrentStepIndex(step);
//     const selectedStep = CLIENT_ADD_STEPS.find(s => s.id === step);
//     navigate(selectedStep?.pathName);
//   };
//
//   // useEffect(() => {
//   //   navigate("")
//   // }, )
//
//   return (
//     <div className="flex flex-col gap-5 p-10 w-full mx-auto max-w-[900px] justify-center items-center">
//       <Stepper value={currentStepIndex} onValueChange={setCurrentStepIndex} className="space-y-8">
//         <StepperNav>
//           {CLIENT_ADD_STEPS.map((step) => (
//             <StepperItem key={step.id} step={step.id}>
//               <StepperTrigger asChild>
//                 <StepperIndicator className="data-[state=completed]:bg-green-500 data-[state=completed]:text-white data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=inactive]:text-gray-500">
//                   {step.id}
//                 </StepperIndicator>
//               </StepperTrigger>
//               {CLIENT_ADD_STEPS.length > step.id && <StepperSeparator className="group-data-[state=completed]/step:bg-green-500" />}
//             </StepperItem>
//           ))}
//         </StepperNav>
//
//         <StepperPanel className="text-sm">
//           {CLIENT_ADD_STEPS.map((step) => (
//             <StepperContent className="w-full flex items-center justify-center" key={step.id} value={step.id}>
//               <div className="bg-white px-7 py-6 rounded-xl max-w-[600px]">
//                 <Outlet />
//               </div>
//             </StepperContent>
//           ))}
//         </StepperPanel>
//
//         <div className="flex items-center justify-between gap-2.5">
//           <Button variant="outline" onClick={() => setCurrentStepIndex((prev) => prev - 1)} disabled={currentStepIndex === 1}>
//             Retour
//           </Button>
//           <Button
//             onClick={() => setCurrentStepIndex((prev) => prev + 1)}
//             disabled={currentStepIndex === CLIENT_ADD_STEPS.length}
//           >
//             Suivant
//           </Button>
//         </div>
//       </Stepper>
//
//       {/*<div>*/}
//       {/*  */}
//       {/*</div>*/}
//     </div>
//   );
// }

export default AddClientStepper